// extracted by mini-css-extract-plugin
export default {"content":"create-new-button_content__syDh1","active":"create-new-button_active__RLKy8","icon":"create-new-button_icon__Bxe--","text":"create-new-button_text__EvIu2"};